<template>
  <v-navigation-drawer :value="drawer" app clipped>
    <v-list-item class="px-2">
      <v-list-item-avatar>
        <v-img src="../assets/avatas.jpeg"></v-img>
      </v-list-item-avatar>

      <v-list-item-title>Your Name</v-list-item-title>

      <v-btn icon @click.stop="navTriggle">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>
    <v-divider></v-divider>

    <v-list dense class="text-h1">
      <v-list-item
        v-for="item in navigation"
        :key="item.title"
        :to="{ name: item.name }"
        :color="setting.COLOR"
        no-action
      >
        <v-list-item-icon>
          <v-icon :color="setting.COLOR">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <!-- <v-list-item-content> -->
        <v-list-item-title :style="{ color: setting.COLOR }">{{
          item.text
        }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "NavDrawer",
  data() {
    return {
      navigation: [
        { text: "Home", icon: "mdi-home-city", name: "home" },
        {
          text: "Trial Comparer",
          icon: "mdi-file-compare",
          name: "trialcomparer",
        },
        { text: "Xpt Viewer", icon: "mdi-file-eye", name: "xptviewer" },
        {
          text: "SAS Viewer",
          icon: "mdi-database-eye",
          name: "sasdataviewer",
        },
      ],
      mini: true,
    };
  },
  mounted() {},
  methods: {},
  computed: mapState({
    drawer: "drawer",
    setting: "setting",
  }),
};
</script>

